'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var names = $(context).find('.gift-aid-confirmation h3');
    var details = $(context).find('.gift-aid-confirmation .field-group');
    $(names[1]).hide();
    $(details[1]).hide();

    function init() {
        context.on('click', '[data-binding="add-member"]', function (e) {
            e.preventDefault();
            // show or hide 2nd member fields
            $(this).parents('.bgbw-submit-membership-form-section').find('.add-member').slideToggle();
            // toggle checkbox
            var checkbox = $(this).next().find('input[type="checkbox"]');
            checkbox.attr('checked', !checkbox.attr('checked'));
        });

        context.on('change', '[data-binding="adult-membership-first-name"]', function () {
            $(details[1]).show();
            $(names[1]).show().text($(this).val() + ':');
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/bgbw/bgbw-submit-membership-form.js
// module id = 216
// module chunks = 0